import { render, staticRenderFns } from "./UserPuzzles.vue?vue&type=template&id=451260d9"
import script from "./UserPuzzles.vue?vue&type=script&lang=ts"
export * from "./UserPuzzles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports